<template>
  <div class="message">
    {{ messcontent  }}
  </div>
</template>

<script>
export default {
  data() {
    return {
        messcontent: "",
    };
  },
  created () {
      if (this.$route.params.mess=='fast') {
        this.messcontent = "获取资源速度过快, 请稍后再试!"
      } else if (this.$route.params.mess=='excess') {
        this.messcontent = "今日获取资源次数较多, 请明日再试!"
      } else {
        location.href = "/main"
      }
  },
  mounted(){
      // document.getElementsByClassName("head-div")[0].style.display="none";
      // document.getElementsByClassName("footer")[0].style.display="none";
  }, 
  methods: {
  }
};
</script>
<style scoped>
.message {
  text-align: center;
  margin: 100px;
  font-size: 16px;
  color: red;
  font-weight: 600;
}
</style>